import { DateTime } from 'luxon';

export function fullDayFormatter(timeStamp) {
  const asLuxon = DateTime.fromMillis(timeStamp);

  return asLuxon.toFormat('yyyy LLL dd,  HH:mm');
}
